(()=>{
  const ROOT=window.Shopify?.routes?.root||'/';
  const money=n=>'₹'+Math.round((Number(n)||0)/100).toLocaleString('en-IN');
  const buzz=()=>{try{navigator.vibrate?.(8)}catch(e){}};
  function init(root){
    if(!root||root.dataset.knBagFix==='1') return;
    root.dataset.knBagFix='1';
    let plan={}, js=[], ds=null;
    const q=s=>root.querySelector(s);
    const qa=s=>Array.from(root.querySelectorAll(s));
    const add=q('[data-add]');
    if(!add) return;
    function readPlan(btn){
      plan={p:Number(btn.dataset.plan)||0,j:Number(btn.dataset.j)||0,d:Number(btn.dataset.d)||0,b:btn.dataset.b||'',limited:btn.dataset.limited==='1'};
      js=[]; ds=null;
      qa('.bb-plan').forEach(x=>x.classList.toggle('active',x===btn));
      paint(); buzz();
    }
    function paint(){
      const needD=plan.d===1;
      const ready=js.length===plan.j&&(!needD||!!ds);
      const mrp=js.reduce((s,x)=>s+(Number(x.p)||0),0)+(ds?(Number(ds.p)||0):0);
      const save=Math.max(0,mrp-plan.p*100);
      const progress=q('[data-progress]'); if(progress) progress.textContent=(js.length+(ds?1:0))+' / '+(plan.j+plan.d);
      const jc=q('[data-jcount]'); if(jc) jc.textContent=js.length+' / '+plan.j;
      const dc=q('[data-dcount]'); if(dc) dc.textContent=(ds?1:0)+' / 1';
      const detail=q('[data-detail]'); if(detail) detail.textContent=plan.limited?'2 Limited Jhumkas':plan.j+' Jhumka'+(plan.j>1?'s':'')+(needD?' + 1 Dupatta':'');
      const summary=q('[data-summary]'); if(summary) summary.textContent=ready?'Your bag is ready ✦':js.length<plan.j?(js.length?'Choose '+(plan.j-js.length)+' more Jhumka'+(plan.j-js.length>1?'s':''):'Start with your Jhumka'):(needD&&!ds?'Now choose your Dupatta':'Your bag is ready ✦');
      const mrpEl=q('[data-mrp]'); if(mrpEl) mrpEl.textContent=money(mrp);
      const dealEl=q('[data-deal]'); if(dealEl) dealEl.textContent='₹'+plan.p;
      const saveEl=q('[data-save]'); if(saveEl) saveEl.textContent='Save '+money(save);
      add.disabled=!ready||!plan.b;
      add.textContent=ready?'ADD MY ₹'+plan.p+' BAG →':'SELECT YOUR PIECES';
      const dg=q('[data-dgroup]'); if(dg) dg.style.display=needD?'block':'none';
      const nx=q('[data-next]'); if(nx) nx.style.display=needD&&js.length===plan.j&&!ds?'block':'none';
      const rg=q('[data-regular-j]'); if(rg) rg.style.display=plan.limited?'none':'grid';
      const lg=q('[data-limited-j]'); if(lg) lg.style.display=plan.limited?'grid':'none';
      qa('[data-slot]').forEach((slot,i)=>{const x=i<3?js[i]:ds;slot.style.backgroundImage=x?.i?'url("'+x.i+'")':'none';slot.classList.toggle('filled',!!x)});
      qa('.bb-card').forEach(card=>{
        const selected=card.dataset.kind==='j'?js.some(x=>x.v===card.dataset.v):ds?.v===card.dataset.v;
        const sold=card.dataset.available!=='true';
        card.classList.toggle('selected',!!selected);
        card.classList.toggle('sold',sold);
        card.disabled=sold||(card.dataset.kind==='j'&&!selected&&js.length>=plan.j);
      });
    }
    function handlePlan(btn,e){
      if(btn.classList.contains('bb-plan-limited')) return;
      e.preventDefault();e.stopImmediatePropagation();readPlan(btn);
    }
    function handleCard(btn,e){
      e.preventDefault();e.stopImmediatePropagation();
      if(btn.disabled) return;
      const x={v:btn.dataset.v,p:btn.dataset.price,i:btn.dataset.img};
      if(btn.dataset.kind==='j'){
        const idx=js.findIndex(y=>y.v===x.v);
        if(idx>=0) js.splice(idx,1); else if(js.length<plan.j) js.push(x);
        if(plan.d&&js.length===plan.j&&!ds) setTimeout(()=>q('.bb-dupatta')?.scrollIntoView({behavior:'smooth',block:'center'}),120);
      }else ds=ds?.v===x.v?null:x;
      buzz(); paint();
    }
    root.addEventListener('click',e=>{
      const planBtn=e.target.closest?.('.bb-plan');
      if(planBtn&&root.contains(planBtn)){handlePlan(planBtn,e);if(planBtn.classList.contains('bb-plan-limited')) return;return;}
      const card=e.target.closest?.('.bb-card');
      if(card&&root.contains(card)){handleCard(card,e);return;}
    },true);
    add.addEventListener('click',async e=>{
      e.preventDefault();e.stopImmediatePropagation();
      if(add.disabled) return;
      add.disabled=true;add.textContent='ADDING…';
      try{
        const jn=js.map(x=>q('[data-kind="j"][data-v="'+x.v+'"] strong')?.textContent?.trim()).filter(Boolean);
        const dn=ds?q('[data-kind="d"][data-v="'+ds.v+'"] strong')?.textContent?.trim():'';
        const res=await fetch(ROOT+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(plan.b),quantity:1,properties:{'Koinur Bag Plan':'₹'+plan.p,'Jhumkas':jn.join(', '),'Dupatta':dn||'None','Selected Pieces':[...jn,...(dn?[dn]:[])].join(' + '),'Limited Edit':plan.limited?'Yes':'No'}}]})});
        if(!res.ok) throw new Error('cart');
        add.textContent='ADDED ✓';buzz();setTimeout(()=>{window.location.href=ROOT+'cart'},350);
      }catch(err){
        const er=q('[data-error]');if(er) er.textContent='Could not add your bag. Please try again.';
        add.disabled=false;add.textContent='TRY AGAIN';
      }
    },true);
    const first=q('.bb-plan.active')||q('.bb-plan');
    if(first){plan={p:Number(first.dataset.plan)||0,j:Number(first.dataset.j)||0,d:Number(first.dataset.d)||0,b:first.dataset.b||'',limited:first.dataset.limited==='1'};paint();}
  }
  function scan(){document.querySelectorAll('#kn-bb').forEach(init);}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',scan); else scan();
  document.addEventListener('shopify:section:load',scan);
  document.addEventListener('shopify:section:unload',()=>{});
})();